import { Injectable } from '@angular/core';
import { UploadBaseService } from 'src/app/shared/services/upload-base.service';
import { ApiVersions } from './api-version';

@Injectable({
  providedIn: 'root',
})
export class MembersResumeService extends UploadBaseService {
  private usersBaseUrl(userId: string) {
    return `users/${userId}`;
  }

  uploadResume = (file, personId: string): Promise<any> =>
    super
      .doUpload(this.usersBaseUrl(personId).concat('/resume'), file, false, ApiVersions.v0_1)
      .toPromise();
}
